/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const putApiOfficesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const putApiOfficesId200Schema = z.any();

export const putApiOfficesIdMutationRequestSchema = z.object({
  name: z.coerce.string().min(1).max(500),
  client: z.object({
    value: z.coerce.number().int(),
    label: z.coerce.string(),
  }),
  isVisible: z.boolean(),
});

export const putApiOfficesIdMutationResponseSchema = z.lazy(
  () => putApiOfficesId200Schema,
);
